export default function Testimonials() {
  const reviews = [
    {
      quote: "The pandabuyspreadsheet system completely changed how I shop online. Instead of wasting hours comparing products across different sites, I open one sheet and see everything side by side. Cannot imagine going back.",
      name: "Emma Richardson",
      role: "Verified Buyer · Fashion Enthusiast",
    },
    {
      quote: "I have tried dozens of deal aggregators and product finders over the years. Nothing comes close to the organization and freshness of this product spreadsheet. The weekly updates mean I am always seeing new finds before they blow up.",
      name: "Marcus Chen",
      role: "Verified Buyer · Tech Reviewer",
    },
    {
      quote: "As someone who shops for a large family, the deal comparison spreadsheet saves me at least five hours every week. The category filters are intuitive and the price comparison columns are genius. Absolutely recommend to anyone who takes shopping seriously.",
      name: "Sofia Laurent",
      role: "Verified Buyer · Lifestyle Blogger",
    },
  ];

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="mb-14">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-foreground-800"></span>
            <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider">
              Verified Reviews
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950">
            Trusted by Smart Shoppers
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((review) => (
            <div
              key={review.name}
              className="flex flex-col p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70"
            >
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 flex-1 italic">
                "{review.quote}"
              </p>
              <div>
                <p className="text-sm font-semibold text-foreground-950">{review.name}</p>
                <p className="text-xs text-foreground-500 mt-0.5">{review.role}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex flex-col lg:flex-row items-start gap-8 mt-16 p-8 md:p-10 rounded-2xl bg-background-100 border border-background-200/70">
          <div className="lg:w-3/5">
            <p className="font-heading text-xl md:text-2xl text-foreground-800 leading-relaxed italic">
              "The pandabuyspreadsheet approach is not just about saving money — it is about
              reclaiming the time you would otherwise spend jumping between tabs, comparing
              specs, and second-guessing your picks. Every sheet is a shortcut to confidence."
            </p>
            <div className="flex items-center gap-3 mt-6">
              <span className="text-sm font-semibold text-foreground-950">James Whitaker</span>
              <span className="flex items-center gap-1 text-xs text-accent-600 font-medium">
                <i className="ri-verified-badge-fill"></i>
                Verified Power User
              </span>
            </div>
          </div>
          <div className="lg:w-2/5">
            <div className="aspect-[3/4] rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20portrait%20of%20stylish%20European%20man%20in%20his%20thirties%20leaning%20against%20a%20textured%20concrete%20wall%2C%20soft%20natural%20window%20lighting%20from%20left%20side%2C%20confident%20yet%20approachable%20expression%2C%20modern%20editorial%20fashion%20photography%2C%20warm%20neutral%20earth%20tones%2C%20high-end%20magazine%20portrait%20quality%2C%20arty%20and%20contemporary%20style&width=600&height=800&seq=testimonial-person-v2&orientation=portrait"
                alt="Verified user testimonial"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}